import { AloBase } from '../alo/AloBase';

export interface IAloDbBaseConstParam {
    id:number|null
    libelle:string|null
    searchString:string|null
    detailLoaded:boolean
}

export class AloDbBase extends AloBase {
            
    public id:number|null
    public libelle:string|null
    public searchString:string|null
    public detailLoaded:boolean
    
    constructor({id,libelle,searchString,detailLoaded }:IAloDbBaseConstParam) {
        super()
        this.id = id        
        this.libelle = libelle                
        this.searchString = searchString    
        this.detailLoaded = detailLoaded
    }
}
